import { BaseProps } from '@oberoninternal/travelbase-website/dist/components/pages/Agenda';
import { GetStaticProps } from 'next';
import addGlobalQuery from '../../utils/addGlobalQuery';
import React from 'react';
import styled from 'styled-components';
import initApolloClient, { PreviewData } from '../../initApolloClient';
import { AgendaDocument, AgendaFragment, AgendaQuery, AgendaQueryVariables } from '../../generated/graphql';
import { DEFAULT_REVALIDATION_TIME } from '../../constants/revalidationTime';
import { addApolloState } from '@oberoninternal/travelbase-website/dist/createApolloClient';
import { gql } from '@apollo/client';
import Seo from '../../components/Seo';
import Activities from '../../components/pages/Actvities';
import { PAGE_MAX } from '@oberoninternal/travelbase-website/dist/components/designsystem/Pagination';

export const query = gql`
    query Agenda($lang: String) {
        entry(section: ["excursions"], site: [$lang]) {
            ...Agenda
        }
    }

    fragment Agenda on excursions_excursions_Entry {
        title
        settingsMetaDescription
        settingsSeoTitle
        localized {
            url
            language
        }
    }
`;

interface Props extends BaseProps {
    entry: AgendaFragment;
}

const Index = (props: Props) => {
    const { title, settingsSeoTitle, settingsMetaDescription, localized } = props.entry;

    return (
        <AgendaWrapper>
            <Seo
                settingsSeoTitle={settingsSeoTitle ?? title ?? ''}
                settingsMetaDescription={settingsMetaDescription ?? ''}
                image={undefined}
                alternates={localized}
            />
            <Activities variant="excursions" amountPerPage={PAGE_MAX} />
        </AgendaWrapper>
    );
};

export default Index;

export const AgendaWrapper = styled.div`
    padding: 0;
`;

export const getStaticProps: GetStaticProps = async context => {
    const { previewData } = context;
    const client = initApolloClient(context.locale as string, { previewData: previewData as PreviewData });

    const { data } = await client.query<AgendaQuery, AgendaQueryVariables>({
        query: AgendaDocument,
        variables: {
            lang: context.locale as string,
        },
    });

    const { entry } = data;

    return {
        ...addApolloState(
            client,
            (await addGlobalQuery(
                {
                    props: {
                        entry,
                    },
                },
                context.locale
            )) as { props: Record<string, unknown> }
        ),
        revalidate: DEFAULT_REVALIDATION_TIME,
    };
};
